import type { WelcomeStep } from "../types/WelcomeFlowTypes";

// The tour's centered intro; anchored steps load live from the Project Dashboard flow guide.
export const projectExistingUserSteps: WelcomeStep[] = [{ key: "project-whats-new", label: "What's new", centered: true }];
